import api from '../api';

const routes = require('routes.js.erb');


const createInvitation = function({ commit }, params) {
  return api.post(routes.api_v5_organization_invitations_path(params.organizationId), params.params)
}

const getInvitations = function({ commit }) {
  return api.get(routes.api_v5_invitations_path());

}

export { createInvitation, getInvitations };